import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchLocation,
  initializeLocationScreen,
  setDeleteConfirmationPopupVisibility,
  exportLocation,
  deleteLocation,
  saveLocationTableState,
} from "../../redux/actions/location";
import Location from '../../component/Location';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../services/PostAPI';
import { APP_URLS } from '../../utils/constant';
import { FILTER } from "../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../utils/date";
function LocationScreen(props) {
  const {
    fetchLocation,
    initLocationScreen,
    showPageLevelLoader,
    locationListview,
    paginationInfo,
    exportLocation,
    isLocationExportError,
    isLocationExportSuccess,
    screenPermissions,
    isLoading,
    deleteLocation,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    isLocationDeleteSuccess,
    isLocationDeleteError,
    savedTableState,
    saveLocationTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId")
    };
  };

  useEffect(() => {
    initLocationScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchLocation(savedParams);
    } else {
      fetchLocation({ sortField: 'id', userId: localStorage.getItem("userId") });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newPyload = {
      ...props,
      userId: localStorage.getItem("userId")
    }
    fetchLocation(newPyload);
  };

  const handleTableStateChange = (tableState) => {
    saveLocationTableState(tableState);
  };

  const handleCreateLocation = () => {
    navigate(APP_URLS.LOCATION.CREATE);
  }
  const editLocationRoute = (id) => {
    const path = generatePath(APP_URLS.LOCATION.EDIT, {
      id,
    });
    navigate(path);
  };
  const copyLocationRoute = (id) => {
    const path = generatePath(APP_URLS.LOCATION.COPY, {
      id,
    });
    navigate(path);
  };
  const locationProps = {
    handleCreateLocation,
    exportLocation,
    isLocationExportError,
    isLocationExportSuccess,
    editLocationRoute,
    copyLocationRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    deleteLocation,
    isLocationDeleteSuccess,
    isLocationDeleteError,
    fetchLocations: loadLazyData,
    tableData: {
      columns: locationListview?.columns,
      rows: locationListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <Location
        {...locationProps}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initLocationScreen: () => dispatch(initializeLocationScreen()),
    fetchLocation: (payload) => dispatch(fetchLocation(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportLocation: (payload) => dispatch(exportLocation(payload)),
    deleteLocation: (payload) => dispatch(deleteLocation(payload)),
    saveLocationTableState: (payload) => dispatch(saveLocationTableState(payload)),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    locationListview: selectLocationsList(state.locationReducer),
    showPageLevelLoader: selectIsLoadingPage(state.locationReducer),
    paginationInfo: selectPaginationInfo(state.locationReducer),
    isPageLevelError: selectIsPageLevelError(state.locationReducer),
    isFetchingGridData: selectIsLoading(state.locationReducer),
    isLocationExportError: selectIsLocationExportError(
      state.locationReducer
    ),
    isLocationExportSuccess: selectIsLocationExportSuccess(
      state.locationReducer
    ),
    shouldOpenDeleteConfirmationPopup: state.locationReducer.shouldOpenDeleteConfirmationPopup,
    isLocationDeleteSuccess: state.locationReducer.isLocationDeleteSuccess,
    isLocationDeleteError: state.locationReducer.isLocationDeleteError,
    isLoading: state.locationReducer.isLoading,
    savedTableState: state.locationReducer.savedTableState,
  };
};

// Connect with reducer 
const selectIsLocationExportError = (locationReducer) =>
  locationReducer.isLocationExportError;
const selectIsLocationExportSuccess = (locationReducer) =>
  locationReducer.isLocationExportSuccess;

const selectIsLoading = (locationReducer) => locationReducer.isLoading;
const selectPaginationInfo = (locationReducer) => locationReducer.paginationInfo;
const selectIsLoadingPage = (locationReducer) => locationReducer.isLoadingPage;
const selectIsPageLevelError = (locationReducer) => locationReducer.isPageLevelError;
const selectLocationsList = (locationReducer) => locationReducer.locationListview;

export default connect(mapStateToProps, mapDispatchToProps)(LocationScreen);
